export enum SetupFlowCommonSteps {
  introduction = 'introduction',
  setupCompleted = 'setupCompleted'
}

export enum SetupFlowIpirSteps {
  microsoftConnected = 'microsoftConnected'
}

export enum SetupFlowEgdSteps {
  regionSelection = 'regionSelection',
  verifyDomain = 'verifyDomain',
  deploymentSetup = 'deploymentSetup',
  emailFlow = 'emailFlow'
}

export type SetupFlowSteps = SetupFlowCommonSteps | SetupFlowIpirSteps | SetupFlowEgdSteps

export enum DeploymentSetupOptions {
  inline = 'inline',
  mxRecord = 'mx'
}

export enum EmailFlowSteps {
  addNewMxRecords = 'addNewMxRecords',
  removeOldMxRecords = 'removeOldMxRecords'
}

export type EmailFlowVerifiedStates = {
  [key in EmailFlowSteps]: boolean
}

export enum IPIRAppTypes {
  InlineMx = 'InlineMx',
  Sentinel = 'Sentinel'
}

export interface InitialSetupFlowSettings {
  ipirSection: boolean
  egdSection: boolean
}
